/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetEMAProvidersRequestBody,
  SetEMAProvidersRequestBody$Outbound,
  SetEMAProvidersRequestBody$outboundSchema,
} from "../components/setemaprovidersrequestbody.js";

export type SetOrganizationRemoteSessionIssuerEMAProvidersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetOrganizationRemoteSessionIssuerEMAProvidersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setEMAProvidersRequestBody: SetEMAProvidersRequestBody;
};

/** @internal */
export type SetOrganizationRemoteSessionIssuerEMAProvidersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetOrganizationRemoteSessionIssuerEMAProvidersSecurity$outboundSchema:
  z.ZodMiniType<
    SetOrganizationRemoteSessionIssuerEMAProvidersSecurity$Outbound,
    SetOrganizationRemoteSessionIssuerEMAProvidersSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setOrganizationRemoteSessionIssuerEMAProvidersSecurityToJSON(
  setOrganizationRemoteSessionIssuerEMAProvidersSecurity:
    SetOrganizationRemoteSessionIssuerEMAProvidersSecurity,
): string {
  return JSON.stringify(
    SetOrganizationRemoteSessionIssuerEMAProvidersSecurity$outboundSchema.parse(
      setOrganizationRemoteSessionIssuerEMAProvidersSecurity,
    ),
  );
}

/** @internal */
export type SetOrganizationRemoteSessionIssuerEMAProvidersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetEMAProvidersRequestBody: SetEMAProvidersRequestBody$Outbound;
};

/** @internal */
export const SetOrganizationRemoteSessionIssuerEMAProvidersRequest$outboundSchema:
  z.ZodMiniType<
    SetOrganizationRemoteSessionIssuerEMAProvidersRequest$Outbound,
    SetOrganizationRemoteSessionIssuerEMAProvidersRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      setEMAProvidersRequestBody: SetEMAProvidersRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        setEMAProvidersRequestBody: "SetEMAProvidersRequestBody",
      });
    }),
  );

export function setOrganizationRemoteSessionIssuerEMAProvidersRequestToJSON(
  setOrganizationRemoteSessionIssuerEMAProvidersRequest:
    SetOrganizationRemoteSessionIssuerEMAProvidersRequest,
): string {
  return JSON.stringify(
    SetOrganizationRemoteSessionIssuerEMAProvidersRequest$outboundSchema.parse(
      setOrganizationRemoteSessionIssuerEMAProvidersRequest,
    ),
  );
}
